<template lang="pug">
b-modal#resetPasswordSub(
  ref="resetPasswordSub"
  :title="$t('ui.combine.reset_password')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$t('ui.login_id')" disabled)
      DebounceInput(
        size="sm"
        type="text"
        :dirty="$v.loginId.$dirty"
        :error="$v.loginId.$error"
        v-model.trim.lazy="$v.loginId.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.loginId" :name="$t('ui.login_id')")
    b-form-group(:label="$t('ui.combine.new_password')")
      DebounceInput(
        size="sm"
        ref="userPwd"
        type="password"
        :dirty="$v.userPwd.$dirty"
        :error="$v.userPwd.$error"
        v-model.trim.lazy="$v.userPwd.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.userPwd" :name="$t('ui.combine.new_password')")
    b-form-group(:label="$t('ui.combine.confirm_password')")
      DebounceInput(
        size="sm"
        type="password"
        :dirty="$v.userPwdConfirm.$dirty"
        :error="$v.userPwdConfirm.$error"
        v-model.trim.lazy="$v.userPwdConfirm.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.userPwdConfirm" :name="$t('ui.combine.confirm_password')", :name2="$t('ui.combine.new_password')")
    //- div.row
    //-   div.col
    //-     b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, email, sameAs, numeric, decimal, helpers } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
const containAlphaNum = helpers.regex("containAlphaNum", /^(?=.*\d)(?=.*[a-zA-Z])/);

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      loginId: "",
      userPwd: "",
      userPwdConfirm: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    }
  },
  validations: {
    loginId: {
      required
    },
    userPwd: {
      required,
      containAlphaNum,
      minLength: minLength(6),
      maxLength: maxLength(50)
    },
    userPwdConfirm: {
      required,
      sameAs: sameAs("userPwd")
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.passwordResetSubUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          account_id: this.$store.getters.accountId,
          login_id: this.item.login_id,
          new_password: this.userPwd,
          audit_by: this.$store.getters.loginId
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.resetPasswordSub.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "reset_password", this.feedback.status);
                  this.$refs.resetPasswordSub.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.loginId = this.item.login_id;
      this.userPwd = '';
      this.userPwdConfirm = '';
      this.$refs.userPwd.$el.focus();
    }
  }
};
</script>
